<template>
    <div  v-if="maxChars !== undefined">
        <textarea class="form-control inputElement" rows="10" :id="'value-'+id" :maxlength="maxChars" autocomplete="off">{{value}}</textarea>
        <span class="help-block">Die Eingabe ist auf {{maxChars}} Zeichen begrenzt</span>
    </div>
    <textarea class="form-control inputElement" rows="10" :id="'value-'+id" autocomplete="off" v-else>{{value}}</textarea>
</template>

<script>
export default {
  name: "TextInput",
  data() {
    return {
      output: {}
    };
  },
  props: ["value", "id", "maxChars"]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/BigTextInput.vue